const PLAN_TREE = 'Tree'
const PLAN_QUIZ = 'Quiz'
const PLAN_BASKET = 'Basket'

export {
  PLAN_TREE,
  PLAN_QUIZ,
  PLAN_BASKET
}
